import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardSidebar from '../components/DashboardSidebar';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translations';
import styles from './AboutHelp.module.css';

function AboutHelpContent() {
  const { language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [1, 2, 3].map((index) => ({
    question: t(`about_help_faq_q${index}`, language),
    answer: t(`about_help_faq_a${index}`, language),
  }));

  const walkthroughSteps = [1, 2, 3, 4, 5, 6].map((index) => ({
    title: t(`about_help_step${index}_title`, language),
    body: t(`about_help_step${index}_body`, language),
  }));

  const feedbackPoints = [1, 2, 3].map((index) =>
    t(`about_help_feedback_point${index}`, language)
  );

  return (
    <div className={`app-container ${styles.openSansScope}`}>
      <NavBar />
      <div className={styles.page}>
        <div className={styles.mainContent}>
          <div className={styles.sidebarWrap}>
            <DashboardSidebar />
          </div>

          <div className={styles.content}>
            <header className={styles.header}>
              <h1 className={styles.title}>{t('about_help_title', language)}</h1>
              <p className={styles.subtitle}>
                {t('about_help_subtitle', language)}
              </p>
            </header>

            <section className={styles.card}>
              <h2 className={styles.sectionTitle}>{t('about_help_overview_title', language)}</h2>
              <p className={styles.bodyText}>
                {t('about_help_overview_body', language)}
              </p>
              <div className={styles.pillRow}>
                <span className={styles.pill}>{t('about_help_pill_ai', language)}</span>
                <span className={styles.pill}>{t('about_help_pill_cultural', language)}</span>
                <span className={styles.pill}>{t('about_help_pill_standards', language)}</span>
              </div>
            </section>

            <section className={styles.card}>
              <h2 className={styles.sectionTitle}>{t('about_help_faq_title', language)}</h2>
              <div className={styles.faqList}>
                {faqs.map((faq, index) => (
                  <div key={faq.question} className={styles.faqItem}>
                    <button
                      className={styles.faqQuestion}
                      onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                      type="button"
                    >
                      <span>{faq.question}</span>
                      <span className={styles.faqSymbol}>{openIndex === index ? '−' : '+'}</span>
                    </button>
                    {openIndex === index && (
                      <p className={styles.faqAnswer}>{faq.answer}</p>
                    )}
                  </div>
                ))}
              </div>
            </section>

            <section className={styles.card}>
              <h2 className={styles.sectionTitle}>{t('about_help_walkthrough_title', language)}</h2>
              <div className={styles.walkthroughBox}>
                {walkthroughSteps.map((step, index) => (
                  <div key={step.title} className={styles.walkthroughStep}>
                    <h3 className={styles.stepTitle}>{`${index + 1}. ${step.title}`}</h3>
                    <p className={styles.bodyText}>{step.body}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className={styles.card}>
              <h2 className={styles.sectionTitle}>{t('about_help_feedback_title', language)}</h2>
              <p className={styles.bodyText}>{t('about_help_feedback_body', language)}</p>
              <ul className={styles.feedbackList}>
                {feedbackPoints.map((point) => (
                  <li key={point} className={styles.feedbackItem}>
                    {point}
                  </li>
                ))}
              </ul>
            </section>

            <section className={styles.card}>
              <h2 className={styles.sectionTitle}>{t('about_help_need_help_title', language)}</h2>
              <p className={styles.bodyText}>
                {t('about_help_need_help_body', language)}
              </p>
              <a className={styles.emailLink} href="mailto:kumuconnectai@gmail.com">
                kumuconnectai@gmail.com
              </a>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AboutHelp() {
  return (
    <ProtectedRoute>
      <AboutHelpContent />
    </ProtectedRoute>
  );
}
